<template>
    <div>
        <az-container>
            <az-form>
                <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                              :pagination.sync="paginacaoInterna" :loading="false"
                              no-data-text="Não há compras diretas disponíveis" hide-actions
                              class="az-table-list table-todas-compras">
                    <template slot="items" slot-scope="props">
                        <tr>
                            <td @click="$emit('acessar', props.item.id)">
                                {{ props.item.dataHoraEncerramento | DateTimeFormater }}
                            </td>
                            <td @click="$emit('acessar', props.item.id)">
                                {{ props.item.processo }}
                                <br>
                                <span v-if="props.item.quantidadeRepeticoes">
                                    <strong> Repetição: {{props.item.quantidadeRepeticoes}} </strong>
                                </span>
                            </td>
                            <td @click="$emit('acessar', props.item.id)">
                                <expansao-texto :tamanho="125" :texto="props.item.objeto"/>
                            </td>
                            <td @click="$emit('acessar', props.item.id)">
                                {{ props.item.tipo | azEnum(tiposCompraDireta)}}
                            </td>
                            <td @click="$emit('acessar', props.item.id)">
                                {{ props.item.orgao }}
                            </td>
                            <td @click="$emit('acessar', props.item.id)">
                                {{ props.item.situacao | azEnum(situacoesCompraDireta) }}
                            </td>
                            <td class="table-actions">
                                <!--Fazer isso aparecer se quiser baixar ata  (só remover && false)-->
                                <botao-download v-if="props.item.situacao === 'ENCERRADA' && false"
                                                @download="$emit('baixarAta', props.item.id)"
                                                :id="'botao-baixar-ata'+props.item.id"
                                                class="mr-3 botao-menor"/>
                                <v-tooltip top>
                                    <a @click="$emit('acessar', props.item.id)" slot="activator">
                                        <i class="fas fa-sign-in-alt" aria-hidden="true"/>
                                        <span class="acao-mobile">Acessar</span>
                                    </a>
                                    Acessar
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <div class="az-pagination">
                    <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
                    <div class="az-select-pagination">
                        <span>Linhas por página:</span>
                        <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                    </div>
                </div>
            </az-form>
        </az-container>
    </div>
</template>

<script>
import {situacoesCompraDireta, tiposCompraDireta} from '@/core/constants'
import BotaoDownload from '../../../components/BotaoDownload'

export default {
    name: 'TodasComprasDiretasTabela',
    components: {BotaoDownload},
    props: ['itens', 'paginacao', 'paginas', 'totalItens'],
    data() {
        return {
            paginacaoInterna: this.paginacao,
            situacoesCompraDireta,
            linhasPorPagina: [10, 25, 50],
            colunas: [
                {
                    value: 'dataHoraEncerramento',
                    text: 'Encerramento',
                    align: 'left',
                    width: '60px',
                    sortable: true,
                    class: 'primary--text'
                },
                {
                    value: 'processo',
                    text: 'Nº Processo',
                    align: 'left',
                    width: '100px',
                    sortable: true,
                    class: 'primary--text'
                },
                {
                    value: 'objeto',
                    text: 'Objeto',
                    align: 'left',
                    width: '200px',
                    sortable: true,
                    class: 'primary--text'
                },
                {
                    value: 'tipo',
                    text: 'Tipo',
                    align: 'left',
                    width: '80px',
                    sortable: true,
                    class: 'primary--text'
                },
                {
                    value: 'orgao',
                    text: 'Órgão',
                    align: 'left',
                    width: '30px',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'situacao',
                    text: 'Situação',
                    align: 'left',
                    width: '50px',
                    sortable: true,
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    text: 'Ações',
                    width: '30px',
                    align: 'center',
                    class: 'primary--text'
                }
            ],
            tiposCompraDireta
        }
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="stylus">
    .az-container
        margin-top 10px
        margin-bottom 60px

    .table-todas-compras
        border solid 2px rgba(169, 169, 169, 0.3)

        .acao-mobile
            display none

        td:hover
            cursor pointer !important

    @media (max-width 720px)
        .table-todas-compras
            td:nth-of-type(1):before
                content "Encerramento:"

            td:nth-of-type(2):before
                content "Nº Processo:"

            td:nth-of-type(3):before
                content "Objeto:"

            td:nth-of-type(4):before
                content "Tipo:"

            td:nth-of-type(5):before
                content "Órgão:"

            td:nth-of-type(6):before
                content "Situação:"

            td:nth-of-type(7):before
                display none

            .acao-mobile
                display inline-block
                margin-left 3px

    @media (max-width 500px)
        .az-container
            margin-bottom 0
</style>
